export const GET_WAREHOUSE_CHECK_CAMPAIGN_NAMES = "GET_WAREHOUSE_CHECK_CAMPAIGN_NAMES"
export const SET_WAREHOUSE_CHECK_CAMPAIGN_NAMES = "SET_WAREHOUSE_CHECK_CAMPAIGN_NAMES"
export const CHECK_NAMES_WH_LOADER = "CHECK_NAMES_WH_LOADER"

export const GET_WAREHOUSE_CABINET_LIMITS = "GET_WAREHOUSE_CABINET_LIMITS"
export const SET_WAREHOUSE_CABINET_LIMITS = "SET_WAREHOUSE_CABINET_LIMITS"
export const GET_WAREHOUSE_CABINET_LIMITS_TOTAL = "GET_WAREHOUSE_CABINET_LIMITS_TOTAL"
export const SET_WAREHOUSE_CABINET_LIMITS_TOTAL = "SET_WAREHOUSE_CABINET_LIMITS_TOTAL"
export const WAREHOUSE_CABINET_LIMITS_LOADER = "WAREHOUSE_CABINET_LIMITS_LOADER"